import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { tr } from 'i18n';
import React from 'react';
import { Inbox } from 'lucide-react';
import styles from './Presentation.module.scss';

export function PageHeader({ icon: Icon, title, description, actions }) {
  useInterfaceLanguage();
  return (
    <header className={styles.pageHeader}>
      <div className={styles.headingGroup}>
        {tr(Icon && <span className={styles.pageIcon} aria-hidden="true"><Icon size={22} strokeWidth={1.8} /></span>)}
        <div className={styles.headingText}>
          <h1>{tr(title)}</h1>
          {tr(description && <p>{tr(description)}</p>)}
        </div>
      </div>
      {tr(actions && <div className={styles.pageActions}>{actions}</div>)}
    </header>
  );
}

export function SectionHeading({ icon: Icon, title, description, actions, tone = 'primary', as: Heading = 'h2' }) {
  useInterfaceLanguage();
  return (
    <div className={styles.sectionHeading}>
      <div className={styles.headingGroup}>
        {tr(Icon && <span className={`${styles.sectionIcon} ${styles[tone] || styles.primary}`} aria-hidden="true"><Icon size={19} strokeWidth={1.8} /></span>)}
        <div className={styles.sectionText}>
          <Heading>{tr(title)}</Heading>
          {tr(description && <p>{tr(description)}</p>)}
        </div>
      </div>
      {tr(actions && <div className={styles.sectionActions}>{actions}</div>)}
    </div>
  );
}

export function EmptyState({ icon: Icon = Inbox, title, description, action, compact = false }) {
  useInterfaceLanguage();
  return (
    <div className={`${styles.emptyState} ${compact ? styles.compact : ''}`}>
      <span className={styles.emptyIcon} aria-hidden="true"><Icon size={24} strokeWidth={1.6} /></span>
      {tr(title && <p className={styles.emptyTitle}>{tr(title)}</p>)}
      {tr(description && <p className={styles.emptyDescription}>{tr(description)}</p>)}
      {tr(action && <div className={styles.emptyAction}>{action}</div>)}
    </div>
  );
}
